"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _directive = _interopRequireDefault(require("./src/directive"));

var _index = _interopRequireDefault(require("./src/index"));

var _default = {
  install: function install(Vue) {
    Vue.use(_directive["default"]);
    Vue.prototype.$skloading = _index["default"];
  },
  directive: _directive["default"],
  service: _index["default"]
};
exports["default"] = _default;